import { render, staticRenderFns } from "./MakingOfSlide.vue?vue&type=template&id=c69caaf6&scoped=true&"
import script from "./MakingOfSlide.vue?vue&type=script&lang=js&"
export * from "./MakingOfSlide.vue?vue&type=script&lang=js&"
import style0 from "./MakingOfSlide.vue?vue&type=style&index=0&id=c69caaf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69caaf6",
  null
  
)

export default component.exports